import moment from "moment";
import React, { useEffect, useState, useContext } from "react";
import Utilities from "../../../../../services/commonservice/utilities";
import { store } from "../../../../../context/StateProvider";
import Module from "../../../../templates/components/Module";
import Table2 from "../../../../templates/components/Table2";
import HPTDatePicker from "../../../../templates/components/HPTDatePicker";
import DimLoader from "../../../../templates/components/DimLoader";
import HPTSelect from '../../../../templates/components/HPTSelect';
import InvoiceService from "../../../../../services/api/invoice.service";
import { useGetLocationProviderServices } from "../../../../../services/cache/CacheService";
import PatientSelector from "../../../../templates/components/PatientSelector";
import CacheUtilities from "../../../../../services/cache/CacheUtilities";

const InvoiceItemCountsTable = (props) => {
    const [invoiceDetails, setInvoiceDetails] = useState();
    const [startDate, setStartDate] = useState(moment().startOf("D"));
    const [endDate, setEndDate] = useState(moment().endOf("D"));
    const [doctorId, setDoctorId] = useState(false);

    const stateAndDispatch = useContext(store);
    const state = stateAndDispatch.state;
    const [isLoader, setIsLoader] = useState(false);
    const [initialMessage, setInitialMessage] = useState(true);
    const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true);
    const [locationId, setLocationId] = useState(state.practiceLocationId || null);
    const [patientId, setPatientId] = useState()
    const [providerList, setProviderList] = useState()
    const [itemDetailsData, setItemDetailsData] = useState({})
    const [tableKey, setTableKey] = useState(0)
    const stateDoctorList = useGetLocationProviderServices();

    useEffect(async () => {
        if (locationId) {
            if (locationId == state.practiceLocationId) {
                setProviderList(stateDoctorList)
            }
            else {
                const locProviderServices = await CacheUtilities.pullServiceForLocationData(locationId);
                setProviderList(locProviderServices)
            }
        } else {
            const locProviderServices = await CacheUtilities.pullServiceForLocationData(null);
            setProviderList(locProviderServices)
        }
        setDoctorId()
    }, [locationId, stateDoctorList]);

    const onPatientChange = (newPatientId) => {
        setPatientId(newPatientId)
    }
    const fetchReport = () => {
        setIsLoader(true);
        let reqObj = {
            StartDate : moment(startDate).toISOString(),
            EndDate : moment(endDate).toISOString()
        };
        if (locationId) {
            reqObj.PracticeLocationId = locationId;
        }
        if (patientId) {
            reqObj.PatientId = patientId
        }
        if (doctorId) {
            reqObj.DoctorId = doctorId
        }
        setInitialMessage(false);
        setItemDetailsData({}); // Clear previous item details when fetching new report
        setTableKey(prev => prev + 1); // Reset table to collapse all expanded rows

        InvoiceService.getInvoiceItemCounts(reqObj)
            .then((res) => {
                console.log(res);
                if (res?.data?.length > 0) {
                    setInvoiceDetails(res.data);
                    setIsLoader(false);
                } else {
                    setInvoiceDetails();
                    setIsLoader(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setInvoiceDetails();
                setIsLoader(false);
            });
    };

    const fetchItemDetails = (itemId) => {
        let reqObj = {
            ItemId: itemId,
            StartDate: moment(startDate).toISOString(),
            EndDate: moment(endDate).toISOString()
        };
        if (locationId) {
            reqObj.PracticeLocationId = locationId;
        }
        if (patientId) {
            reqObj.PatientId = patientId
        }
        if (doctorId) {
            reqObj.DoctorId = doctorId
        }

        return InvoiceService.getInvoiceItemsReport(reqObj)
            .then((res) => {
                //console.log('Item details:', res);
                if (res?.data?.data?.length > 0) {
                    return res.data.data;
                }
                return [];
            })
            .catch((err) => {
                console.log('Error fetching item details:', err);
                return [];
            });
    };

    const columns = [
        {
            id: "subData",
            Header: "",
            accessor: (tc) => ""
        },
        {
            id: "productOrService",
            Header: "Item Name",
            accessor: tc => tc.productOrService,
            Footer: () => 'Grand Total'
        },
        {
            id: "itemType",
            Header: "Item Type",
            accessor: tc => tc.itemType
        },
        {
            id: "unitPrice",
            Header: "Unit Price",
            meta: { sum: true, currency: true, numeric: true },
            accessor: tc => Utilities.toDollar(tc.unitPrice),
            Footer: info => {
                const total = React.useMemo(
                    () =>
                        info.rows.reduce((sum, row) => row.original.unitPrice + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        },
        {
            id: "quantityTotal",
            Header: "Quantity",
            accessor: tc => tc.quantityTotal,
            meta: { sum: true, numeric: true },
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.quantityTotal) + sum, 0),
                    [info.rows]
                )
                return <>{total}</>
            },
        },
        {
            id: "priceTotal",
            Header: "Price Total",
            accessor: tc => Utilities.toDollar(tc.priceTotal),
            meta: { sum: true, currency: true, numeric: true },
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.priceTotal) + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        },
        {
            id: "taxTotal",
            Header: "Tax Total",
            accessor: tc => Utilities.toDollar(tc.taxTotal),
            meta: { sum: true, currency: true, numeric: true },
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.taxTotal) + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        },
        {
            id: "discountTotal",
            Header: "Discount Total",
            accessor: tc => Utilities.toDollar(tc.discountTotal),
            meta: { sum: true, currency: true, numeric: true },
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.discountTotal) + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        },
        {
            id: "total",
            Header: "Total Amount",
            accessor: tc => Utilities.toDollar(tc.total),
            meta: { sum: true, currency: true, numeric: true },
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.total) + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        }
    ];

    const tableSubColumns = [
        {
            id: "invoiceDate",
            Header: "Invoice Date",
            accessor: (row) => moment(row.invoiceDate).format('MM/DD/YYYY')
        },
        {
            id: "invoiceNumber",
            Header: "Invoice Number",
            accessor: (row) => row.invoiceNumber
        },
        {
            id: "patientName",
            Header: "Patient Name",
            accessor: (row) => row.patientName
        },
        {
            id: "providerName",
            Header: "Provider Name",
            accessor: (row) => row.providerName
        },
        {
            id: "practiceLocation",
            Header: "Location",
            accessor: (row) => row.practiceLocation
        },
        {
            id: "quantity",
            Header: "Quantity",
            meta: { sum: true,  numeric: true },
            accessor: (row) => row.quantity,
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.quantity) + sum, 0),
                    [info.rows]
                )
                return <>{total}</>
            },
        },
        {
            id: "unitPrice",
            Header: "Unit Price",
            meta: { sum: true, currency: true, numeric: true },
            accessor: (row) => Utilities.toDollar(row.unitPrice),
            Footer: info => {
                const total = React.useMemo(
                    () =>
                        info.rows.reduce((sum, row) => row.original.unitPrice + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        },
        {
            id: "lineSubTotal",
            Header: "SubTotal",
            meta: { sum: true, currency: true, numeric: true },
            accessor: (pp) => { return Utilities.toDollar(pp.lineSubTotal) },
            Footer: info => {
                const total = React.useMemo(
                    () =>
                        info.rows.reduce((sum, row) => row.original.lineSubTotal + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        },
        {
            id: "calculatedDiscountAmount",
            Header: "Discount",
            meta: { sum: true, currency: true, numeric: true },
            accessor: (row) => row.calculatedDiscountAmount && row.calculatedDiscountAmount > 0 ? Utilities.toDollar(row.calculatedDiscountAmount) : '-',
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.calculatedDiscountAmount) + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        },
        {
            id: "lineTaxAmount",
            Header: "Tax",
            meta: { sum: true, currency: true, numeric: true },
            accessor: (row) => row.lineTaxAmount ? Utilities.toDollar(row.lineTaxAmount) : '-' ,
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.lineTaxAmount) + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        },
        {
            id: "lineTotal",
            Header: "Total",
            meta: { sum: true, currency: true, numeric: true },
            accessor: (row) => Utilities.toDollar(row.lineTotal),
            Footer: info => {
                const total = React.useMemo(
                    () => info.rows.reduce((sum, row) => (row.original.lineTotal) + sum, 0),
                    [info.rows]
                )
                return <>{Utilities.toDollar(total)}</>
            },
        }
    ];

    const ItemDetailsRow = ({ row }) => {
        const [loading, setLoading] = useState(false);
        const [data, setData] = useState(itemDetailsData[row.itemId] || null);

        useEffect(() => {
            if (!itemDetailsData[row.itemId] && row.itemId) {
                setLoading(true);
                fetchItemDetails(row.itemId).then((details) => {
                    setItemDetailsData(prev => ({ ...prev, [row.itemId]: details }));
                    setData(details);
                    setLoading(false);
                });
            } else {
                setData(itemDetailsData[row.itemId]);
            }
        }, [row.itemId, itemDetailsData]);

        return (
            <div className="mt-3 mb-3">
                <Table2
                    data={data}
                    columns={tableSubColumns}
                    loading={loading}
                />
            </div>
        );
    };

    const subDataAccessor = (row) => {
        return <ItemDetailsRow row={row} />;
    };

    useEffect(() => {
        // Here you would typically fetch the doctor list and item list
        // Similar to how ProductSummary fetches manufacturers and products
    }, []);

    return (
        <>
            {isLoader &&
                <DimLoader loadMessage="Processing" />
            }
            <div className="row d-flex g-3">
                <div className='col-12 m-p-0'>
                    <Module title="Filters">
                        <div className='row d-flex'>
                            <div className='col-12 row d-flex justify-content-center mx-0 align-items-end report-filters'>
                                <HPTDatePicker
                                    setLocationId={setLocationId}
                                    locationClearable={isLocationClearable}
                                    startDate={startDate}
                                    endDate={endDate}
                                    setEndDate={setEndDate}
                                    setStartDate={setStartDate}
                                    includeAll
                                />
                                <div className='col-md col-12'>
                                    <div className='ui field'>
                                        <label>Patient</label>
                                        <PatientSelector onSelected={onPatientChange} showAddPatient={false} />
                                    </div>
                                </div>
                                <div className='col-md col-12'>
                                    <div className='ui field'>
                                        <label>Provider</label>
                                        <HPTSelect
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={providerList}
                                            name="doctorId"
                                            isDisabled={!providerList}
                                            isClearable={true}
                                            isSearchable
                                            value={providerList && doctorId ? providerList.find(obj => obj.id === doctorId) : null}
                                            onChange={e => {
                                                if (e?.id) {
                                                    setDoctorId(e.id)
                                                }
                                                else {
                                                    setDoctorId()
                                                }
                                            }}
                                            loadingMessage="Providers are loading..."
                                            getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                                            getOptionValue={(option) => option.id}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-auto col-12">
                                    <button
                                        className="btn btn-primary"
                                        onClick={e => { e.preventDefault(); fetchReport() }}
                                        title="Pull Report"
                                    >
                                        <i className="icon arrow circle right" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Module>
                </div>
                <div className="col-12 m-p-0">
                    <Module title="Invoice Item Counts">
                        <Table2
                            key={tableKey}
                            hiddenColumns={['subData']}
                            export
                            searchable
                            title="Invoice Item Counts"
                            data={invoiceDetails}
                            allowMultipleExpanded={false}
                            columns={columns}
                            loading={isLoader}
                            subDataAccessor={subDataAccessor}
                            subDataId="subData"
                            initialMessage={initialMessage}
                        />
                    </Module>
                </div>
            </div>
        </>
    );
};

export default InvoiceItemCountsTable;